// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__25NZS","footer":"ModalError_footer__3qre8"};